import { Stack, Accordion, AccordionSummary, AccordionDetails, Typography, Chip } from "@mui/material";
import { ExpandMore } from "@mui/icons-material";
import dayjs from "dayjs";
import { useQuestionnaireContext } from "../../../../contexts/QuestionnaireContext";
import { PlanoDeTratamentoAccordion } from "./PlanoDeTratamentoAccordion";
import { useAttendanceSpecialtyIndex } from "@/hooks/useAttendanceSpecialtyIndex";
import { buildQrDisplayInfo } from "@/utils/resolveAttendanceSpecialty";
import { GenericTimeline } from "../GenericTimeline";
import { useState } from "react";

const style: any = {
  Concluído: "#007C6D",
  Parcialmente: "#FBBB3C",
  Falhou: "#EF4352",
};

const styleType = {
  "long-term": "#183B56",
  "short-term": "#5F6C85",
};

export function PlanoDeTratamentoHistory() {
  const { historyValues } = useQuestionnaireContext();
  const specialtyIndex = useAttendanceSpecialtyIndex();

  const responseEntries = historyValues?.map((el: any) => el?.resource);

  const treatmentPlansResponses = responseEntries?.map((el: any) => {
    const awnserDate = el?.authored;
    const answerDate = dayjs(el?.authored)?.format("DD MMM YYYY");
    const filterItems = el?.item
      ?.filter((e: any) => e?.text === "Planos de tratamento")?.[0]
      ?.item?.filter((subItem: any) => {
        return (
          // subItem?.item?.[1]?.answer?.[0]?.valueCoding &&
          subItem?.item?.[2]?.answer?.[0]?.valueCoding &&
          subItem?.item?.[0]?.answer
        );
      });
    const displayInfo = buildQrDisplayInfo(el, specialtyIndex);
    return { awnserDate, answerDate, filterItems, displayInfo };
  });

  const verifyResponse = treatmentPlansResponses?.filter(
    (el: any) => el.filterItems?.length
  );

  // Agrupa respostas por dia
  const groupedByDay = verifyResponse?.reduce((acc: any, item: any) => {
    const day = dayjs(item.awnserDate).format("DD/MM/YYYY");
    if (!acc[day]) {
      acc[day] = {
        day,
        awnserDate: item.awnserDate,
        items: [],
      };
    }
    acc[day].items.push(item);
    return acc;
  }, {}) || {};

  // Converte para array para usar na timeline
  const timelineData = Object.values(groupedByDay);

  return (
    <Stack spacing={1}>
      <GenericTimeline
        data={timelineData}
        dotColor={style}
        component={(data: any, index: number) => (
          <DayAccordion 
            day={data.day} 
            items={data.items} 
            style={style} 
            styleType={styleType}
            defaultExpanded={index === 0} 
          />
        )}
      />
    </Stack>
  );
}

// Componente Accordion que agrupa planos de tratamento por dia
function DayAccordion({ day, items, style, styleType, defaultExpanded }: any) {
  const [expanded, setExpanded] = useState(defaultExpanded);

  // Conta o total de planos dentro de todos os questionários do dia
  const totalPlanos = items.reduce((total: number, item: any) => {
    return total + (item?.filterItems?.length || 0);
  }, 0);

  return (
    <Accordion
      expanded={expanded}
      onChange={(_, isExpanded) => setExpanded(isExpanded)}
      sx={{
        width: "100%",
        boxShadow: "1px 1px 16px 1px rgba(0, 0, 0, 0.1)",
        border: "1px solid",
        borderColor: "neutral200.main",
        borderRadius: 1,
      }}
    >
      <AccordionSummary expandIcon={<ExpandMore />}>
        <Stack direction="row" alignItems="center" spacing={2} width="100%">
          <Chip 
            label={`${totalPlanos} ${totalPlanos === 1 ? 'plano' : 'planos'}`}
            size="small"
            sx={{ fontWeight: 500 }}
          />
        </Stack>
      </AccordionSummary>
      
      <AccordionDetails>
        <Stack spacing={1}>
          {items.map((data: any, idx: number) => (
            <PlanoDeTratamentoAccordion 
              key={idx} 
              style={style} 
              styleType={styleType}
              data={data} 
              index={idx} 
            />
          ))}
        </Stack>
      </AccordionDetails>
    </Accordion>
  );
}
